import * as React from 'react';

import { useSetAtom } from 'jotai';

import { $populateBrokeredOrderFormAction } from '../_state/brokeredOrderForm.state';
import { BrokeredOrderDetailRecord } from '../types/brokeredOrder';

type Props = {
  order: BrokeredOrderDetailRecord | null | undefined;
};

export const usePopulateBrokeredOrderForm = ({ order }: Props) => {
  const populateForm = useSetAtom($populateBrokeredOrderFormAction);

  React.useEffect(() => {
    populateForm(order);
  }, [order, populateForm]);
};
